module.exports = __webpack_public_path__ + "img/section_1@2x.c5517be0.png";